import { EyeIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type RevealIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function RevealIconButton({
  label = 'Revelar',
  className = '',
  ...props
}: RevealIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-amber-50 hover:text-amber-700 disabled:opacity-50 ${className}`}
      {...props}
    >
      <EyeIcon className="h-5 w-5" />
    </button>
  );
}
